export class EmailQuote {
    primaryEmail: string;
    comment: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/email-quote.model.ts